import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';

import { Http } from '../../../../support';
import { Auth } from '../../../../support';
import Ordered from '../utilities/Ordered';
import LoadingButton from '../../../../facturotopia/LoadingButton';
import ColumnsOrder from '../../support/ordenar-columnas/ColumnsOrder';

const ComprobantesColumnsOrderUpsert = (props) => {
  const orderByColumns = (columns, reset = false, defecto = false) => {
    const {
      empresa: { config = {} },
    } = Auth.getData() || {};

    const { columnas_factura = [] } = config;

    if ((columnas_factura.length === 0 && reset === false) || defecto === true) {
      let defaultColumns = columns.slice(0, 11);

      defaultColumns = defaultColumns.map((item) => {
        return item.key;
      });

      return new Ordered().apply(columns, defaultColumns);
    } else if (reset === true) {
      return [columns, []];
    }

    return new Ordered().apply(columns, columnas_factura);
  };

  let listing = orderByColumns(columnasFactura);

  const [busy, setBusy] = useState(false);
  const [columns, setColumns] = useState(listing[0]);
  const [horizontal, setHorizontal] = useState(false);
  const [selections, setSelections] = useState(listing[1]);

  const handleOnChangeOrder = (columns, selections) => {
    setColumns(columns);
    setSelections(selections);
  };

  const onChangeHorizontal = () => {
    setHorizontal(!horizontal);
  };

  const handleOnChangeReset = () => {
    let listing = orderByColumns(columnasFactura, true);

    setColumns(listing[0]);
    setSelections(listing[1]);
  };

  const handleOnChangeDefault = () => {
    let listing = orderByColumns(columnasFactura, false, true);

    setColumns(listing[0]);
    setSelections(listing[1]);
  };

  const submit = async () => {
    setBusy(true);

    try {
      const { empresa } = Auth.getData() || {};

      let keys = selections.map((item) => {
        return item.key;
      });

      const params = {
        nombre: empresa.nombre,
        config: {
          columnas_factura: keys,
        },
        include: 'config',
      };

      let response = await Http.put(`api/empresas/${empresa.id}`, params);

      const original = Auth.getData();

      const data = {
        ...original,
        empresa: response.data ?? {},
      };

      await Auth.setData(data);

      props.history.replace('/cuenta/panel-configuraciones');
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.message || 'Error al organizar columnas.',
      });
    } finally {
      setBusy(false);
    }
  };

  const isValid = selections.length !== 0;

  return (
    <>
      <div className="page-header">
        <Link to="/cuenta/panel-configuraciones">&#8592; Panel</Link>
      </div>
      <>
        <strong>Ordena las columnas para el listado de tus facturas.</strong>
        <br />
        <br />
        1. Selecciona una columna, y automáticamente hace un listado con palomita ordenadas conforme vayas
        seleccionando.
        <br />
        2. Para quitar una columna de la lista, haz click nuevamente sobre la columna que deseas quitar.
      </>
      <Row>
        <Col
          xs={12}
          sm={12}
          md={12}
          lg={12}
        >
          <div className="py-3">
            <LoadingButton
              type="button"
              disabled={!isValid}
              loading={busy || false}
              onClick={submit}
              className="mr-2"
            >
              {busy === true ? 'Guardando...' : 'Guardar columnas ordenadas'}
            </LoadingButton>

            <Button
              className="mr-2"
              variant="secondary"
              type="button"
              onClick={onChangeHorizontal}
            >
              Horizontal
            </Button>

            <Button
              className="mr-2"
              variant="secondary"
              type="button"
              onClick={handleOnChangeReset}
            >
              Reset
            </Button>
            <Button
              variant="secondary"
              type="button"
              onClick={handleOnChangeDefault}
            >
              Default
            </Button>
          </div>

          <ColumnsOrder
            data={columns || []}
            horizontal={horizontal}
            selections={selections || []}
            onChange={handleOnChangeOrder}
          />
        </Col>
      </Row>
    </>
  );
};

const columnasFactura = [
  {
    key: 'status',
    title: 'Status',
  },
  {
    key: 'version',
    title: 'Versión',
  },
  {
    key: 'timbrado_at',
    title: 'Fecha',
  },
  {
    key: 'tipo',
    title: 'Tipo',
  },
  {
    key: 'emisor_rfc',
    title: 'Emisor',
  },
  {
    key: 'receptor_rfc',
    title: 'Receptor',
  },
  {
    key: 'metodo_de_pago',
    title: 'M. Pago',
  },
  {
    key: 'forma_de_pago',
    title: 'F. Pago',
  },
  {
    key: 'total',
    title: 'Total',
  },
  {
    key: 'serie',
    title: 'Serie/Folio',
  },
  {
    key: 'uuid',
    title: 'Folio Fiscal',
  },
  {
    key: 'emisor_razon_social',
    title: 'R.S. Emisor',
  },
  {
    key: 'receptor_razon_social',
    title: 'R.S. Receptor',
  },
  {
    key: 'codigo',
    title: 'Código',
  },
];

export default withRouter(ComprobantesColumnsOrderUpsert);
